import React from "react";
import { motion } from "framer-motion";

import Desktop from "../imgs/about/about-desktop.png";
import Tablet from "../imgs/about/about-tablet.png";

const About = () => {
  const items = [
    {
      id: 1,
      text: "Take expertly curated quizzes to test your knowledge",
    },
    {
      id: 2,
      text: "Compete in interactive contests to prove your ability",
    },
    {
      id: 3,
      text: "Earn rewards in discounts, premium resources, and more",
    },
  ];

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Delay between child animations
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 }, // Start slightly below
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <div className="bg-[#052035] w-full pt-14 pb-24 mt-16" id="about">
      <div className="flex flex-col lg:flex-row items-center justify-between">
        <div className="mx-5 md:mx-10 lg:ml-20 md:mr-0 w-[90%] md:w-[80%] lg:w-[40%] about">
          <h1 className="text-3xl lg:text-4xl text-center sm:text-center md:text-center lg:text-left text-white mb-5">
            Who We <span className="text-[#3BF5CA] font-bold">Are</span>
          </h1>
          <p className="text-center sm:text-center md:text-center lg:text-left text-white font-normal text-sm lg:text-base">
            You deserve more than basic skill-testing and skill-building
            platforms. Our survey shows that most learners, like you, want a way
            to test your knowledge and earn meaningful rewards—not just another
            certificate or badge.
          </p>

          <p className="text-center sm:text-center md:text-center lg:text-left text-white font-normal mt-5 text-sm lg:text-base">
            Hallimo makes this possible. We are the ultimate Test-to-Earn
            platform, where learners in tech and creative arts take part in fun
            quizzes and contests, proving their abilities while earning rewards
            like discounts, gifts, internships and more.
          </p>
        </div>

        <img
          src={Tablet}
          className="sm:flex lg:hidden mt-20"
          height={400}
          width={280}
        />
        <img
          src={Desktop}
          className="hidden lg:flex about-img"
          height={350}
          width={700}
        />
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-12 lg:px-16 mt-24">
        <h1 className="text-3xl lg:text-4xl text-center text-white mb-5">
          How you earn using
          <br />
          <span className="text-[#3BF5CA] font-bold">Hallimo</span>
        </h1>
        <p className="text-center text-white font-normal text-sm lg:text-base">
          Hallimo rewards learners through fun quizzes and contests.
          <br />
          Prove your abilities, earn rewards, play some more.
        </p>
      </div>

      <motion.div
        className="max-w-7xl mx-auto px-8 lg:px-16 mt-10"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }} // Trigger when 20% of the container is visible
        variants={containerVariants}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <motion.div
              key={item.id}
              className="bg-white flex flex-col items-center justify-center p-10 rounded-xl"
              variants={cardVariants}
            >
              <div className="rounded-full bg-[#3BF5CA] flex items-center justify-center w-16 h-16">
                <h1 className="text-[#052035] text-xl">{item.id}</h1>
              </div>
              <p className="text-center mt-4 text-sm">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default About;
